




































































































import { defineComponent } from "@vue/composition-api"
import { useGetters } from 'vuex-composition-helpers';

export default defineComponent({

  name : "Wtfis",

  setup() {

    const { user } = useGetters({ user: "auth/user" } as any);

    return{
      user
    }

  }
});
